// extracted by css-extract-rspack-plugin
export default {"MergeQueueSectionText":"MergeQueueSection-module__MergeQueueSectionText__kit0_"};